export default {
  organization: 'Организация',

  // Details
  organizationDetails: 'Детали организации',
  organizationDetailsDescription: 'Управление названием организации.',
  name: 'Название',
  organizationNamePlaceholder: 'Название организации',
  domain: 'Домен',
  domainPlaceholder: 'example.com',
  organizationNameRequired: 'Название организации обязательно',
  organizationUpdated: 'Организация обновлена',
  failedToUpdateOrganization: 'Не удалось обновить организацию',

  // Domain verification
  organizationDomain: 'Домен организации',
  organizationDomainDescription:
    'Подтвердите корпоративный домен, чтобы автоматически одобрять приглашения с совпадающим доменом email.',
  loadingDomain: 'Загрузка домена...',
  addDomain: 'Добавить домен',
  editDomain: 'Редактировать домен',
  saveDomain: 'Сохранить домен',
  domainNotConfigured: 'Корпоративный домен ещё не настроен.',
  domainPending: 'Ожидает подтверждения',
  domainVerified: 'Подтверждён',
  domainUnverified: 'Не подтверждён',
  addDnsRecord: 'Добавьте эту DNS-запись',
  dnsPropagationDescription:
    'Обновление DNS может занять до 48 часов. Не удаляйте запись после подтверждения.',
  dnsRecordNotFound: 'DNS-запись не найдена',
  dnsRecordNotFoundDescription:
    'Проверьте значение TXT в корне домена и повторите попытку после обновления DNS.',
  dnsRecordDetails: 'DNS-запись',
  dnsRecordType: 'Тип',
  dnsRecordValue: 'Значение',
  verifyDomain: 'Проверить домен',
  checkDomainAgain: 'Проверить снова',
  domainChallengeCreated: 'Инструкция для DNS готова',
  domainChallengeFailed: 'Не удалось добавить домен',
  domainAlreadyClaimed: 'Этот домен уже подключён к другой организации.',
  domainInvalid:
    'Введите корректный корпоративный домен, например company.com.',
  changeDomainWarning:
    'При изменении домена будет создан новый токен, а текущее подтверждение сбросится.',
  dnsCheckUnavailable: 'Проверка DNS временно недоступна',
  dnsCheckUnavailableDescription:
    'Статус подтверждения не изменён. Повторите проверку DNS через несколько минут.',
  domainRemoved: 'Домен удалён',
  domainRemoveFailed: 'Не удалось удалить домен',
  removeDomain: 'Удалить домен',
  removeDomainTitle: 'Удалить домен организации?',
  removeDomainDescription:
    'Автоматическое одобрение по домену email будет отключено. Приглашения в организацию продолжат работать.',
  cancel: 'Отмена',

  // Invite link
  inviteLink: 'Ссылка для приглашения',
  inviteLinkDescription:
    'Поделитесь ссылкой, чтобы пригласить людей в организацию. Пользователям без совпадающего подтверждённого домена потребуется одобрение владельца.',
  loadingInviteLink: 'Загрузка ссылки для приглашения...',
  failedToLoadInviteLink: 'Не удалось загрузить ссылку для приглашения.',

  // Members
  membersTitle: 'Участники',
  nameColumn: 'Имя',
  emailColumn: 'Email',
  roleColumn: 'Роль',
  loadingMembers: 'Загрузка участников...',
  failedToLoadMembers: 'Не удалось загрузить участников.',
  noMembersFound: 'Участники не найдены.',
  loadingRequests: 'Загрузка запросов...',
  failedToLoadRequests: 'Не удалось загрузить запросы на вступление.',
  noPendingRequests: 'Нет ожидающих запросов.',
  requested: 'Запрос {{date}}',
  noEmail: 'Нет email',
  approve: 'Одобрить',
  reject: 'Отклонить',
  removeMemberTitle: 'Удалить участника',
  removeMemberConfirm:
    'Вы уверены, что хотите удалить {{name}} из организации? Все данные о нем будут удалены.',
  approveRequestTitle: 'Одобрить запрос',
  rejectRequestTitle: 'Отклонить запрос',
  requestActionConfirm: 'Вы уверены, что хотите {{action}} запрос от {{name}}?',
  memberApproved: 'Участник одобрен',
  requestRejected: 'Запрос отклонён',
  failedToRemoveMember: 'Не удалось удалить участника',
  failedToAction: 'Не удалось {{action}} запрос',
  memberRemoved: 'Участник удалён',
  membersTab: 'Участники',
  members: 'Участники',
  joinRequestsTab: 'Запросы на вступление',
  joinRequests: 'Запросы на вступление',
  ownerBadge: 'владелец',
  ownerRole: 'Владелец',
  adminRole: 'Админ',
  memberRole: 'Участник',
  memberRoleUpdated: 'Роль участника обновлена',
  failedToUpdateMemberRole: 'Не удалось обновить роль участника',
  email: 'Email',
  role: 'Роль',
  removeMember: 'Удалить участника',
  approveJoinRequest: 'Одобрить запрос на вступление',
  rejectJoinRequest: 'Отклонить запрос на вступление',
  joinRequestConfirm: 'Вы уверены, что хотите {{action}} запрос от {{name}}?',
  failedToLoadJoinRequests: 'Не удалось загрузить запросы на вступление.',
  leaveOrganization: 'Покинуть организацию',
  leaveOrganizationConfirm:
    'Вы уверены, что хотите покинуть организацию? Вы потеряете доступ к её воркспейсам.',
  leaveOrganizationSuccess: 'Вы покинули организацию',
  leaveOrganizationFailed: 'Не удалось покинуть организацию',

  // Onboarding
  loadingWorkspace: 'Загрузка обзора воркспейса...',
  unableToLoadWorkspace: 'Не удалось загрузить обзор воркспейса',
  pleaseTryAgain: 'Пожалуйста, попробуйте ещё раз.',
  freePlanOnboarding: 'Онбординг Free плана',
  createFirstWorkspace: 'Создайте первый воркспейс',
  createFirstWorkspaceDescription:
    'Настройте воркспейс, чтобы начать работу с командой.',
  freePlanDescription:
    'Вы используете бесплатный план, который включает базовую настройку для запуска первого воркспейса.',
  maxWorkspaces: 'Макс. воркспейсов',
  maxSeats: 'Макс. мест',
  maxPlugins: 'Макс. плагинов',
  maxMessagesPerWorkspaceMonth: 'Сообщений на воркспейс в месяц',
  historyRetention14Days: 'Хранение истории чата',
  historyRetentionDaysValue: '{{count}} дн.',
  workspaceLimitReachedNotification: 'Достигнут лимит воркспейсов',
  workspaceCreationUnavailableNotification: 'Создание воркспейса недоступно',
  askAdminForAccess:
    'Попросите владельца или администратора организации предоставить доступ к воркспейсу.',
  noWorkspaceAccessTitle: 'Нет доступа к воркспейсу',
  noWorkspaceAccessDescription:
    'Вы в {{name}}. Попросите администратора добавить вас.',
  startWithOneWorkspace:
    'Начните с одного воркспейса. Вы можете обновить план позже, если команде понадобится больше.',

  // Org invites
  loadingInvite: 'Загрузка приглашения...',
  somethingWentWrong: 'Что-то пошло не так',
  unableToLoadInvite:
    'Не удалось загрузить данные приглашения. Попробуйте позже.',
  joinOrganization: 'Присоединиться к {{name}}',
  signInOrCreateAccount:
    'Войдите или создайте аккаунт, чтобы присоединиться к организации.',
  logIn: 'Войти',
  signUp: 'Зарегистрироваться',
  invitedToJoin: 'Вы приглашены присоединиться к этой организации.',
  failedToJoin: 'Не удалось присоединиться. Попробуйте ещё раз.',
  joinOrganizationButton: 'Присоединиться к организации',
  joining: 'Присоединение...',
  welcomeTitle: 'Добро пожаловать!',
  joinedSuccessfully:
    'Вы успешно присоединились к {{name}}. Перенаправление...',
  requestSubmitted: 'Запрос отправлен',
  requestSubmittedDescription:
    'Ваш запрос на вступление в {{name}} отправлен. Владелец организации рассмотрит его в ближайшее время.',
  waitForApproval: 'Вы получите доступ после одобрения запроса.',
  goToWaitingPage: 'Перейти на страницу ожидания',
  requestRejectedTitle: 'Запрос отклонён',
  requestRejectedDescription:
    'Ваш запрос на вступление в {{name}} был отклонён. Свяжитесь с администратором организации.',
  goToHome: 'На главную',
  previousRequestRejected:
    'Ваш предыдущий запрос на вступление в {{name}} был отклонён. Вы можете подать новый запрос.',
  applyAgain: 'Подать заново',
  submitting: 'Отправка...',
  inviteNotFound: 'Приглашение не найдено',
  inviteInvalidOrExpired: 'Эта ссылка приглашения недействительна или истекла.',
  unableToJoin: 'Невозможно присоединиться',
  alreadyInOtherOrg:
    'Вы уже состоите в другой организации. Необходимо покинуть текущую организацию.',
  organizationFull: 'Организация заполнена',
  organizationFullDescription:
    'Эта организация достигла максимального количества мест. Свяжитесь с администратором.',

  // Workspace invites
  inviteLoadingWs: 'Загрузка приглашения...',
  inviteNotFoundWs: 'Приглашение не найдено',
  inviteInvalidOrExpiredWs:
    'Эта ссылка приглашения недействительна или истекла.',
  joinWorkspace: 'Присоединиться к воркспейсу',
  invitedToWorkspace: 'Вы приглашены присоединиться к {{name}}.',
  alreadyInWorkspace: 'Вы уже в этом воркспейсе.',
  joinedWorkspaceSuccessfully: 'Вы успешно присоединились.',
}
